<template>
  <!--我的页面-->
  <tk-container
    :status="status"
    :probeType="3"
    infiniteScroll
    @refresh="refreshInit"
    style="background: #f5f5f5;"
    @scroll="watchScroll"
    ref="resetItsMine"
    @loadingMore="recommendedProducts"
  >
    <!--头部-->
    <gradient-header slot="header" :z-index="zIndex" :is-show-back="false"
                     :is-header-color="isHeaderColor" :back-style="false" :icon-name="'return'">
      <tk-flex slot="right-menu">
        <div @click="$push('/common/messageNotification')">
          <tkui-badge :show="tipsStatus">
            <tk-icon size="25" :color="isHeaderColor ? '#000000' : '#fff'">news</tk-icon>
          </tkui-badge>
        </div>
      </tk-flex>
    </gradient-header>
    <!--数据渲染-->
    <div class="its-mine-bg">
      <!--背景图片-->
      <div
        style="position: relative;"
        :class="{ 'its-mine-bg-style': isCountyAccount }"
      >
        <div
          :style="{ backgroundImage: `url(${themeBackground})`,
           height: isUpShelf ? 190 + 'px' : 255 + 'px' }"
          class="mine-bg-image">
          <div class="mine-bg-info">
            <!--个人信息-->
            <tk-flex
              between
              middle
              class="m-x-12 m-b-15 mine-bg-color"
              @click.native="$push({path: '/itsMine/postsProfile', query: {id: userInfo.objectId}})"
            >
              <tk-flex
                middle
              >
                <div class="bg-color-avatar">
                  <tk-image :src="avatarSrc" width="50" height="50"></tk-image>
                </div>
                <div class="m-l-10">
                  <div class="font-20 font-bold">{{fullName}}</div>
                  <div v-if="isCountyAccount" class="bg-color-level m-t-2">{{levelName | membershipLevel}}</div>
                </div>
              </tk-flex>
              <div class="font-12">个人主页 <tk-icon size="12" color="#fff">rightarrow</tk-icon></div>
            </tk-flex>
            <!--帖子相关信息-->
            <tk-flex v-if="!isUpShelf" around class="m-x-12 m-t-15 mine-bg-color">
              <tk-flex
                column
                center
                @click.native="$push({path: '/common/postsList', query: {type: 'post', id: userInfo.objectId}})"
                class="tk-grid-3"
              >
                <div class="font-20 font-bold">{{postsSum | transform}}</div>
                <div class="font-12 m-t-2">发帖</div>
              </tk-flex>
              <tk-flex
                column
                center
                @click.native="$push({path: '/common/userList', query: {type: 'watch', id: userInfo.objectId}})"
                class="tk-grid-3"
              >
                <div class="font-20 font-bold">{{watchSum | transform}}</div>
                <div class="font-12 m-t-2">关注</div>
              </tk-flex>
              <tk-flex
                column
                center
                @click.native="$push({path: '/common/userList', query: {type: 'fans', id: userInfo.objectId}})"
                class="tk-grid-3"
              >
                <div class="font-20 font-bold">{{fansSum | transform}}</div>
                <div class="font-12 m-t-2">粉丝</div>
              </tk-flex>
              <tk-flex
                column
                center
                @click.native="$push({path: '/itsMine/praisePosts', query: {id: userInfo.objectId}})"
                class="tk-grid-3"
              >
                <div class="font-20 font-bold">{{praiseNum | transform}}</div>
                <div class="font-12 m-t-2">获赞</div>
              </tk-flex>
            </tk-flex>
            <!--厂家客户订单-->
            <div class="m-x-12 m-t-10" v-if="isFactoryAccount">
              <mine-card
                :type="'clientOrder'"
                :title="'客户订单'"
                :width="100"
                :commodity-arr="clientOrderList"
                :is-more="true"
                :height="50"
              >
              </mine-card>
            </div>
            <!--终端我的订单-->
            <div class="m-x-12 m-t-15" v-if="isTerminalAccount">
              <mine-card
                :type="'myOrder'"
                :title="'我的订单'"
                :width="100"
                :commodity-arr="myOrderList"
                :is-more="true"
                :height="50"
              >
              </mine-card>
            </div>
          </div>
        </div>
        <!--会员中心图片-->
        <div class="mine-bg-member" v-if="isCountyAccount" @click="$push('/itsMine/memberCenter')">
          <tk-image :src="'https://s3.moke.cloud/dianpei/35a46782-961f-48d8-87b9-5074199ac88b.png'" height="53" class="bg-member-image"></tk-image>
        </div>
      </div>
      <div style="height: 41px" v-if="isFactoryAccount || isTerminalAccount"></div>
      <!--县代我的订单-->
      <div class="m-x-12 m-t-10" v-if="!isFactoryAccount && isCountyAccount">
        <mine-card
          :type="'myOrder'"
          :title="'我的订单'"
          :width="100"
          :commodity-arr="myOrderList"
          :is-more="true"
          :height="50"
        >
        </mine-card>
      </div>
      <!--县代客户订单-->
      <div class="m-x-12 m-t-10" v-if="isCountyAccount">
        <mine-card
          :type="'clientOrder'"
          :title="'客户订单'"
          :width="100"
          :commodity-arr="clientOrderList"
          :is-more="true"
          :height="50"
        >
        </mine-card>
      </div>
      <!--县代我的钱包-->
      <div class="m-x-12 m-t-10" v-if="isCountyAccount">
        <mine-card
          :type="'wallet'"
          :title="'我的钱包'"
          :width="100"
          :commodity-arr="walletList"
          :is-more="false"
          :height="50"
        >
        </mine-card>
      </div>
      <!--我的功能-->
      <div class="m-x-12 m-t-10">
        <mine-card
          :type="'mineFeatures'"
          :title="'我的功能'"
          :width="100"
          :commodity-arr="mineFeatures"
          :is-more="false"
          :height="50"
        >
        </mine-card>
      </div>
      <!--为你推荐数据-->
      <infinite-list :title="'为你推荐'" :infinite-list-pad="'p-x-12'" :products-data="getPriceProcessing(recommendedProductsData, judgeTimeRule)" :color="'#000000'"></infinite-list>
    </div>
  </tk-container>
</template>

<script>
import mineCard from '@/components/mineCard'
import { priceProcessing } from '@/assets/help/tool'
let bgRound = 'https://s3.moke.cloud/dianpei/dc031a36-1f3f-4f20-ae1c-f5ba15378f70.png'
export default {
  components: {
    mineCard
  },
  data () {
    return {
      status: 'loading', // 页面状态
      zIndex: 100, // 头部层
      messageTimer: null, // 轮询消息定时id
      isHeaderColor: false, // 判断头部颜色切换
      themeBackground: bgRound, // 主题背景图片
      postsSum: 0, // 发帖数
      praiseNum: 0, // 获赞数
      watchSum: 0, // 关注数
      fansSum: 0, // 粉丝数
      myOrderList: [ // 我的订单数组
        {
          icon: 'pendingpayment',
          pathType: 'pendingpayment',
          text: '待付款'
        },
        {
          icon: 'tobereceived',
          pathType: 'tobereceived',
          text: '待收货'
        },
        {
          icon: 'tobecommented',
          pathType: 'toBeEvaluated',
          text: '待评价'
        },
        {
          icon: 'returns',
          pathType: 'returnExchange',
          text: '退换货'
        }
      ],
      clientOrderList: [ // 客户订单
        {
          image: 'https://s3.moke.cloud/dianpei/cc1a592e-acb2-4c7f-ad46-94232fa9b424.png',
          pathType: 'toBeShipped',
          text: '待发货'
        },
        {
          image: 'https://s3.moke.cloud/dianpei/cf936b6f-277d-4788-b4cf-4c49c974da22.png',
          pathType: 'pendingReceipt',
          text: '已发货'
        },
        {
          image: 'https://s3.moke.cloud/dianpei/f423323d-b532-4220-b230-8980428b5e42.png',
          pathType: 'completed',
          text: '已评价'
        },
        {
          image: 'https://s3.moke.cloud/dianpei/3277080e-21c2-4e42-88ce-d4058e4f2ee9.png',
          pathType: 'returnExchange',
          text: '退换货'
        }
      ],
      walletList: [ // 钱包数据
        {
          number: 0,
          pathType: 'happyBean',
          text: '欢乐豆'
        },
        {
          number: 0,
          pathType: 'luckyStar',
          text: '幸运星'
        },
        {
          number: 0,
          pathType: 'couponIssues',
          text: '优惠券'
        },
        {
          number: 0,
          pathType: 'freightVouchers',
          text: '运费券'
        }
      ],
      mineFeatures: [ // 我的功能
        {
          icon: 'sales',
          pathType: 'sales',
          text: '我的销量'
        },
        {
          icon: 'myclient',
          pathType: 'myclient',
          text: '我的客户'
        },
        {
          icon: 'importantnotice',
          pathType: 'importantnotice',
          text: '重要通知'
        },
        {
          icon: 'problem',
          pathType: 'problem',
          text: '常见问题'
        },
        {
          icon: 'onlineservice',
          pathType: 'onlineservice',
          text: '在线客服'
        },
        {
          icon: 'comment',
          pathType: 'comment',
          text: '意见建议'
        },
        {
          icon: 'lianxiwomen',
          pathType: 'lianxiwomen',
          text: '联系我们'
        },
        {
          icon: 'guanyuwomen',
          pathType: 'guanyuwomen',
          text: '关于我们'
        },
        {
          icon: 'mycollection',
          pathType: 'mycollection',
          text: '我的收藏'
        },
        {
          icon: 'addressmanagement',
          pathType: 'addressmanagement',
          text: '地址管理'
        },
        {
          icon: 'xieyi',
          pathType: 'protocol',
          text: '隐私查看'
        }
      ],
      wallet: null, // 钱包数据
      timeRule: {}, // 限时抢购时间规则
      recommendedProductsData: [] // 为你推荐商品数据获取
    }
  },
  computed: {
    // 用户姓名
    fullName () {
      if (this.isFactoryAccount) {
        return this.userInfo.fullName ? this.userInfo.fullName : (this.userInfo.name ? this.userInfo.name : '用户')
      }
      return this.userInfo.name ? this.userInfo.name : '用户'
    },
    // 用户头像
    avatarSrc () {
      return this.userInfo.avatar ? this.userInfo.avatar : this.defaultImage
    },
    // 判断抢购时间是否有效
    judgeTimeRule () {
      if (!this.timeRule) return false
      let endSum = new Date(this.timeRule.endTime).getTime()
      let nowSum = new Date().getTime()
      return nowSum - endSum < 0
    },
    // 消息提示状态
    tipsStatus () {
      return !!(this.userInfo && this.userInfo.tipsStatus && this.userInfo.tipsStatus.redShow)
    }
  },
  activated () {
    this.setStatusBar('light')
    if (this.isHeaderColor) { this.setStatusBar('dark') }
    this.messageTimer = setInterval(this.getUpdateMessage, 2000)
    this.activatedInit() // 获取钱包数据
  },
  beforeRouteLeave (to, from, next) {
    this.setStatusBar('dark')
    clearInterval(this.messageTimer)
    next(true)
  },
  methods: {
    /**
    * 页面初始化
    * @date: 2020/4/12
    */
    async getInit () {
      try {
        await this.getLimitedTimeRule() // 获取限时抢购的时间 （只获取1条）
        await this.getMinePosts() // 获取自己发帖数据
        await this.getMineWatch() // 获取自己关注数据
        await this.getFansWatch() // 获取粉丝数
        if (this.isFactoryAccount) {
          this.mineFeatures = this.mineFeatures.filter(s => { return s.pathType !== 'addressmanagement' })
        } else if (this.isTerminalAccount) {
          this.mineFeatures = this.mineFeatures.filter(s => { return s.pathType !== 'sales' })
        }
        if (this.isUpShelf) {
          this.mineFeatures = this.mineFeatures.filter(s => { return s.pathType !== 'importantnotice' })
        }
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
    * 无论返回页面还是新进页面必须走的接口
    * @date: 2020/4/27
    */
    async activatedInit () {
      await this.getInit()
      if (!this.isCountyAccount) { return }
      await this.getWallet() // 获取钱包信息
      this.walletList[2].number = await this.statisticsNum('vouchers', { type: 'coupons', user: this.userInfo.objectId, status: 'notUsed' }) // 获取优惠券数量
      this.walletList[3].number = await this.statisticsNum('vouchers', { type: 'freightVouchers', user: this.userInfo.objectId, status: 'notUsed' }) // 获取优惠券数量
    },
    /**
     * 监听页面滚动改变头部背景颜色
     * @date: 2020/3/26
     */
    watchScroll (scrollTop) {
      this.isHeaderColor = scrollTop > 12
      this.setStatusBar(this.isHeaderColor ? 'dark' : 'light')
      this.$forceUpdate()
    },
    /**
     * 页面错误时点击重新加载按钮 @resetInfiniteScroll
     * @date: 2020/3/24
     */
    async refreshInit () {
      this.recommendedProductsData = []
      await this.getInit()
      this.$refs.resetItsMine.resetInfiniteScroll()
    },
    /**
     * 限时抢购时间获取
     * @date: 2020/4/12
     */
    async getLimitedTimeRule () {
      let isoStartDate = new Date().toISOString()
      let startTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/startTime').catch(e => {
        return { data: null }
      })
      let endTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/endTime').catch(e => {
        return { data: null }
      })
      // 判断时间是否存在
      if (!startTime.data || !endTime.data) {
        this.timeRule = null
        return
      }
      let startSum = new Date(startTime.data).getTime()
      let nowSum = new Date(isoStartDate).getTime()
      if (nowSum <= startSum) {
        this.timeRule = null
        return
      }
      this.timeRule = {
        startTime: startTime.data,
        endTime: endTime.data
      }
    },
    /**
    * / 获取自己发帖数据  postsSum发帖数praiseNum获赞数
    * @date: 2020/4/12
    */
    async getMinePosts () {
      let res = await this.$tkParse.getList('/classes/InformationPosts', {
        params: {
          limit: 10000,
          keys: 'userFans',
          where: {
            author: this.userInfo.objectId
          }
        }
      })
      if (res.length) {
        this.praiseNum = 0
        this.postsSum = res.length
        res.forEach(s => {
          if (!s.userFans) { s.userFans = [] }
          this.praiseNum += s.userFans.length
        })
      } else {
        this.postsSum = 0
        this.praiseNum = 0
      }
    },
    /**
    * 获取自己关注数据 watchSum关注数
    * @date: 2020/4/12
    */
    async getMineWatch () {
      this.watchSum = await this.statisticsNum('watchPostUser', { userFans: this.userInfo.objectId })
    },
    /**
    * 获取粉丝数fansSum粉丝数
    * @date: 2020/4/12
    */
    async getFansWatch () {
      this.fansSum = await this.statisticsNum('watchPostUser', { author: this.userInfo.objectId })
    },
    /**
     * 获取用户钱包
     * @date: 2020/4/11
     */
    async getWallet () {
      let wallet = await this.$tkParse.getList('/classes/wallet', {
        params: {
          limit: 1,
          where: {
            user: this.userInfo.objectId
          }
        }
      })
      if (wallet.length) {
        this.wallet = wallet[0]
        this.walletList[0].number = this.wallet.happyBean ? this.wallet.happyBean : 0
        this.walletList[1].number = this.wallet.luckyStar ? this.wallet.luckyStar : 0
      } else {
        this.wallet = null
      }
    },
    /**
     * 为你推荐数据获取
     * @date: 2020/3/24
     */
    async recommendedProducts (page, next) {
      let commodityData = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 10,
          skip: page * 10,
          order: '-sales',
          where: {
            shelvesStatus: 'shelves'
          }
        }
      })
      this.recommendedProductsData = [...this.recommendedProductsData, ...commodityData]
      if (commodityData.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    },
    /**
     * 工具转换
     * @date: 2020/4/10
     */
    getPriceProcessing (arr, rule) {
      return priceProcessing(arr, rule)
    },
    /**
     * @Description: 更新消息提示
     * @author xiaozan
     * @date 2020/5/6
     */
    async getUpdateMessage () {
      if (!this.userInfo) { return }
      let messages = await this.$tkParse.getList(`/classes/messageNotification`, {
        params: {
          limit: 1,
          order: '-createdAt',
          where: {
            userRecords: {
              $nin: [this.userInfo.objectId]
            }
          }
        }
      }).catch(() => { clearInterval(this.messageTimer) })
      let obj = {}
      if (!messages.length) { // 没有新消息
        obj.tipsStatus = {
          redShow: false
        }
      }
      if (messages.length) {
        obj.tipsStatus = {
          redShow: true
        }
      }
      await this.$store.dispatch('updateUserMsg', obj)
    }
  }
}
</script>

<style scoped lang="scss">
  /*背景图样式*/
.its-mine-bg {
  width: 100%;
  .its-mine-bg-style {
    border-bottom-left-radius: 50% 20px;
    border-bottom-right-radius: 50% 20px;
    overflow: hidden;
  }
  .mine-bg-image {
    width: 100%;
    background-position: 100% 100%;
    background-size: cover;
    height: 264px;
    background-repeat: no-repeat;
  }
  .mine-bg-info {
    position: absolute;
    top: 70px;
    width: 100%;
  }
  .mine-bg-color {
    color: #fff;
    .bg-color-avatar {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      overflow: hidden;
      border: 3px solid #F2E6BB;
    }
    .bg-color-level {
      min-width: 60px;
      text-align: center;
      line-height: 20px;
      height: 20px;
      background-color: rgba(246, 233, 187, 0.1);
      border-radius: 10px;
      font-size: 12px;
      color: rgba(246, 233, 187, 1);
    }
  }
  .mine-bg-member {
    position: absolute;
    bottom: 0;
    padding: 0 12px;
    width: 100%;
    font-size: 0;
    left: 0;
    .bg-member-image {
      width: 100%;
    }
  }
}
</style>
